import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import cn from 'classnames';

import { actions as currentCountryActions } from '../../redux/profiles/country-code';
import { FIELDS_TYPE } from '../../constants';
import TextInput from '../TextInput/index';
import SelectCustom from '../SelectCustom';
import { useMobileInput } from './useMobileInput';
import styles from './index.styl';

export function MobilePhone({
  name,
  label,
  onChange,
  placeholder,
  disabled,
  value,
  phoneCode,
  onBlur,
  className,
  dirty,
  formatMessage,
}) {
  const { codeControl, phoneControl, validation } = useMobileInput(
    value,
    formatMessage,
    phoneCode,
  );
  const {
    options,
    code,
    handleCodeChange,
    handleSetCountryIsoCode,
  } = codeControl;
  const { handlePhoneChange, phone } = phoneControl;
  const { limit, validate } = validation;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(currentCountryActions.set(handleSetCountryIsoCode(code)));
  }, []);

  const onPhoneChange = phoneValue => {
    handlePhoneChange(phoneValue);
    const errors = validate(phoneValue);
    const fullPhone = code + phoneValue;
    onChange(fullPhone, dirty, errors);
  };

  const onCodeChange = option => {
    if (option.value === code) return;
    dispatch(currentCountryActions.set(handleSetCountryIsoCode(option.value)));
    handleCodeChange(option);
    onPhoneChange('');
  };

  const handleBlur = () => {
    if (!onBlur) return;

    const errors = validate(phone);
    onBlur(phone, true, errors);
  };

  return (
    <div className={cn(styles.root, className)}>
      <span className={styles.label}>{label || placeholder}</span>
      <div className={styles.wrapper}>
        <SelectCustom
          className={styles.select}
          onChange={onCodeChange}
          options={options}
          value={code}
        />
        <TextInput
          className={styles.input}
          name={name}
          type="number"
          placeholder={placeholder}
          onChange={onPhoneChange}
          disabled={disabled}
          limit={limit}
          onBlur={handleBlur}
          value={phone}
        />
      </div>
    </div>
  );
}

MobilePhone.defaultProps = {
  name: FIELDS_TYPE.MOBILE_PHONE,
};

MobilePhone.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  formatMessage: PropTypes.func,
  onChange: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  dirty: PropTypes.bool,
  onBlur: PropTypes.func,
  className: PropTypes.string,
  phoneCode: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/MobilePhone/index.jsx